<template>
  <div
    class="d-flex-column justify-start align-start gap-20"
    style="margin-top: 12px"
  >
    <h4 class="t-white font-family-1 title-h5 f-w-600">
      {{ $t("new_text.select_desired_nukes") }}
    </h4>

    <div
      class="d-flex-column select_honor_picker justify-start align-start gap-24"
    >
      <div class="d-flex-row md-row-to-col">
        <button
          class="picker_option d-flex-row gap-16"
          v-for="packOption in items"
          :key="packOption"
          @click.stop="() => selectNuke(packOption)"
          :class="[isSelectedNuke(packOption) && 'selected']"
        >
          <p class="t-white medium-l font-family-2 white-space-no">
            {{ packOption.title }}
          </p>
          <Tooltip :text="$t(packOption.description)" :position="'top'">
            <PoiIcon />
          </Tooltip>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { calculateCurrency } from "~/calculate/calculatePrice";
import Tooltip from "~/components/custom/Tooltip.vue";
import PoiIcon from "~/components/icons/PoiIcon.vue";
const gameStore = useGameStore();
const userStore = useUserStore();
const checkoutStore = useCheckoutStore();
const items = computed(() => {
  const pps = gameStore.getGamePack.prices || [];
  if (pps.length > 0) {
    return pps;
  }
  return [];
});

const renderPrice = (packOption) => {
  if (packOption.type === "free") {
    return packOption.type;
  } else if (packOption.type === "variable") {
    return `${packOption.price}%`;
  } else if (packOption.type === "fixed") {
    return `${parseFloat(calculateCurrency(packOption.price)).toFixed(
      2
    )}${handleCurrency(getUserCurrency)}`;
  } else {
    return `${userStore.getUserCurrencyCode}${parseFloat(
      packOption.price
    ).toFixed(2)}`;
  }
};

const isSelectedNuke = (option) => {
  const optionsSelected = checkoutStore.getDetails?.items || [];
  if (optionsSelected.includes(option.id)) {
    return true;
  }
  return false;
};

const selectNuke = (option) => {
  const selected = checkoutStore.getDetails?.items || [];
  if (isSelectedNuke(option)) {
    const otherItems = selected?.filter((sel) => sel !== option.id);
    checkoutStore.setDetails({
      items: [...otherItems],
    });
  } else {
    checkoutStore.setDetails({
      items: [...selected, option.id],
    });
  }
};
</script>
